import { useApi } from './useApi';
import { getMe } from '../api/endpoints';
import { USER_AUTH_ENABLED } from '../features/users/roles';

interface CurrentStaff {
  /** ログインユーザーに紐づく担当者コード（取得できない場合は null） */
  staffCode: string | null;
  /** 入力担当者欄をロックすべきか（認証有効かつ staff_code 取得済みのときのみ true） */
  locked: boolean;
  loading: boolean;
}

/**
 * ログイン中のユーザーに紐づく入力担当者コードを返す。
 *
 * 認証が有効（VITE_ENABLE_USER_AUTH=true）で、かつ getMe から staff_code を
 * 取得できたときだけ `locked=true` を返す。MVP（認証なし）や staff_code 未紐づけ
 * の場合は `locked=false` とし、呼び出し側は従来どおり手入力を許可する。
 */
export function useCurrentStaff(): CurrentStaff {
  const me = useApi(() => (USER_AUTH_ENABLED ? getMe() : Promise.resolve(null)), []);
  const staffCode = me.data?.user?.staff_code || null;
  return {
    staffCode,
    locked: USER_AUTH_ENABLED && !!staffCode,
    loading: USER_AUTH_ENABLED && me.loading,
  };
}
